import { render, staticRenderFns } from "./ModalPause.vue?vue&type=template&id=033a13b1"
import script from "./ModalPause.vue?vue&type=script&lang=js"
export * from "./ModalPause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports